.container {
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
  align-items: flex-start;
  justify-content: flex-start;
  color: var(--color-semantic-text-neutral30);
  text-align: left;
}

.list {
  padding-left: 2.1rem;
}

.list .listItem {
  list-style-type: disc;
}
